export const LUX_PAGE_TYPE = {
    home: 'Home',
    category: 'Category Page',
    product: 'Product Page',
};

export const ORDER_COUNTER = 1;

export const CUSTOM_DATA = {
    ORDER: 'order.confirmed',
    VERSION: 'release_version',
};
